import React from "react"
import SEO from "../components/Seo"
import GetInTouch from "../components/GetInTouch"
import LayoutDark from "../components/LayoutDark"

const Contact = () => {
  return (
    <LayoutDark>
      <SEO title="Contact Us" />
      <GetInTouch />
    </LayoutDark>
  )
}

export default Contact
